// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3HgV4","title":"Header_title__3Glvb","side":"Header_side__1eFqz"};